import React, {Fragment, useRef, useState} from 'react';
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import ListEdit from "../UI/ListEdit";
import ModalFormInputRow from "../UI/ModalFormInputRow";
import ModalForm from "../UI/ModalForm";
import Box from "../UI/Box";
import {toast} from "react-toastify";
import {useProductFreePairs} from "../../hooks/useProductFreePairs";
import {useProducts} from "../../hooks/useProducts";
import {createProductFreePair, deleteProductFreePair, getProductFreePair, updateProductFreePair} from "../../api/eventGroupApiClient";

const ProductFreePairList = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [productFreePair, setProductFreePair] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [submitCount, setSubmitCount] = useState(0);
    const selectPurchaseProductRef = useRef(null);
    const selectFreeProductRef = useRef(null);
    const {productFreePairs, pagination} = useProductFreePairs(page, pageSize, submitCount);
    const {products} = useProducts(null, null, 1, 200, 0);

    const handleCreateButtonClick = () => {
        setIsUpdate(false);
        setShowModal(true)
    }

    const handleEditIconClick = (productFreePairId) => {
        setIsUpdate(true);
        const productFreePair = getProductFreePair(productFreePairId);

        productFreePair
            .then(
                (data) => {
                    setProductFreePair(data)
                    setShowModal(true)
                }
            )
            .catch(
                (error) => console.log(error)
            );
    }

    const handleCreateSubmit = (event) => {
        event.preventDefault();
        const selectedPurchaseProductId = selectPurchaseProductRef.current.value === '0' ? null : selectPurchaseProductRef.current.value;
        const selectedFreeProductId = selectFreeProductRef.current.value === '0' ? null : selectFreeProductRef.current.value;

        createProductFreePair(selectedPurchaseProductId, selectedFreeProductId)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const handleDeleteIconClick = (productFreePairId) => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('Are you sure?')) {
            deleteProductFreePair(productFreePairId)
                .then(() => {
                    setSubmitCount(prevCount => prevCount + 1);
                    toast.success('Success!');
                })
                .catch(
                    (error) => {
                        toast.error(error.message);
                    }
                );
        }
    }

    const handleEditSubmit = (event) => {
        event.preventDefault();
        const selectedPurchaseProductId = productFreePair.productFreePairId;
        const selectedFreeProductId = selectFreeProductRef.current.value === '0' ? null : selectFreeProductRef.current.value;

        updateProductFreePair(selectedPurchaseProductId, selectedFreeProductId)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Id',
        'Purchase product',
        'Free product',
        'Actions'
    ];

    const columns = {
        functionParams : ['productFreePairId'],
        dataKeys       : [
            'productFreePairId',
            'purchaseProductName',
            'freeProductName'
        ],
    }

    return (
        <Fragment>
            <Box>
                <Button title='Create product free pair' handleClick={handleCreateButtonClick}/>
                <ListEdit
                    headers={listHeaders}
                    items={productFreePairs}
                    columns={columns}
                    pagination={pagination}
                    handleEditIconClick={handleEditIconClick}
                    handleDeleteIconClick={handleDeleteIconClick}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
            {showModal && (
                <Modal>
                    <form onSubmit={isUpdate ? handleEditSubmit : handleCreateSubmit}>
                        <ModalForm
                            title={isUpdate ? 'Update product free pair' : 'Create product free pair'}
                            saveButtonTitle={isUpdate ? 'Update' : 'Create'}
                            handleCancelButtonClick={() => setShowModal(false)}
                        >
                            <ModalFormInputRow title='Purchase product'>
                                {products && productFreePair && (
                                    <select defaultValue={isUpdate ? productFreePair.purchaseProductId : null} ref={selectPurchaseProductRef} className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline">
                                        <option key={0} value={0}>No purchase product</option>
                                        {products.map((option) => (
                                            <option key={option.productId} value={option.productId}>{option.name}</option>
                                        ))}
                                    </select>
                                )}
                            </ModalFormInputRow>
                            <ModalFormInputRow title='Free product'>
                                {products && productFreePair && (
                                    <select defaultValue={isUpdate ? productFreePair.freeProductId : null} ref={selectFreeProductRef} className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline">
                                        <option key={0} value={0}>No free product</option>
                                        {products.map((option) => (
                                            <option key={option.productId} value={option.productId}>{option.name}</option>
                                        ))}
                                    </select>
                                )}
                            </ModalFormInputRow>
                        </ModalForm>
                    </form>
                </Modal>
            )}
        </Fragment>
    );
}

export default ProductFreePairList;